<div class="border-b">
  <div class="navigation flex items-center container">
    @for (item of items$ | async; track item) {
      <rms-navigation-item [item]="item" />
    }
  </div>
</div>
